<script>
  import { onDestroy, onMount } from "svelte";
  import { navigateTo } from "svelte-router-spa";
  import { PRConnect } from "@projectroom/ui-lib";
  import { _ } from "svelte-i18n";

  let eventList = [];

  onMount(() => {
    PRConnect.send("/api/Event/getEventList", {}, (data) => {
      if (data.header.status === "success") {
        eventList = data.result;
      }
    });
  });

  const isEarlierThanStartDate = (eventInfo) => {
    return new Date().getTime() <= new Date(eventInfo.startDate).getTime();
  };

  const isLaterThanEndDate = (eventInfo) => {
    return new Date().getTime() >= new Date(eventInfo.endDate).getTime();
  };

  const isBetweenEventPeriod = (eventInfo) => {
    return (
      new Date().getTime() >= new Date(eventInfo.startDate).getTime() &&
      new Date().getTime() < new Date(eventInfo.endDate).getTime()
    );
  };
</script>

<div class="ava-event">
  {#if eventList.length > 0}
    <div class="event-title">
      <div class="e-title">
        <strong class="bold-text-7">{$_("project.index.0_0")}</strong>
      </div>
    </div>
    <div class="event-con-wrap">
      {#each eventList as event}
        <div
          class="event-con pointer"
          on:click={() => navigateTo(`/event/${event.id}`)}
        >
          <img
            src={event.thumbnailContent}
            loading="lazy"
            alt=""
            class="image-142"
          />
          <div class="event-box">
            <div class="event-box-con">
              {#if isEarlierThanStartDate(event)}
                <div class="open-noti">예정</div>
              {:else if isLaterThanEndDate(event)}
                <div class="open-noti none">마감</div>
              {:else}
                <div class="open-noti">진행중</div>
              {/if}
              {#if event.eventType === "RECOMMEND"}
                <div class="participate">{event.cnt}명 참여</div>
              {/if}
            </div>
            <div class="admin-hambuger-menu hide">
              <div class="menu-button"></div>
              <div class="hambuger-popup">
                <div class="frofile-correct">
                  <div>
                    <a href="#" class="link">프로필 수정</a>
                  </div>
                </div>
                <div class="copy">
                  <a href="#" class="link green">복제</a>
                </div>
                <div class="delete">
                  <a href="#" class="link red">삭제</a>
                </div>
              </div>
            </div>
          </div>
          <div class="event-title1">{event.thumbnailTitle}</div>
          <div class="event-sub1">{event.thumbnailSubTitle}</div>
        </div>
      {/each}
      <div class="event-con">
        <img
          src="/static/images/Frame-7.png"
          loading="lazy"
          alt=""
          class="image-142"
        />
        <div class="event-box">
          <div class="event-box-con">
            <div class="open-noti none">마감</div>
            <div class="participate hide">112명 참여</div>
          </div>
          <div class="admin-hambuger-menu">
            <div class="menu-button"></div>
            <div class="hambuger-popup">
              <div class="frofile-correct">
                <div>
                  <a href="#" class="link">프로필 수정</a>
                </div>
              </div>
              <div class="copy">
                <a href="#" class="link green">복제</a>
              </div>
              <div class="delete">
                <a href="#" class="link red">삭제</a>
              </div>
            </div>
          </div>
        </div>
        <div class="event-title1">캐릭터 달리기 게임 이벤트</div>
        <div class="event-sub1">캐릭터가 살아났다! 최강의 러너는 누구?</div>
      </div>
      <div class="event-con">
        <img
          src="/static/images/Frame-2.png"
          loading="lazy"
          alt=""
          class="image-142"
        />
        <div class="event-box">
          <div class="event-box-con">
            <div class="open-noti none">마감</div>
            <div class="participate hide">112명 참여</div>
          </div>
        </div>
        <div class="event-title1">아바톡 공모전 Vol.2 내일은 국민캐릭</div>
        <div class="event-sub1">캐릭터를 보유한 작가 및 기업 참여 가능</div>
      </div>
      <div class="event-con">
        <img
          src="/static/images/Frame-3.png"
          loading="lazy"
          alt=""
          class="image-142"
        />
        <div class="event-box">
          <div class="event-box-con">
            <div class="open-noti none">마감</div>
            <div class="participate hide">112명 참여</div>
          </div>
        </div>
        <div class="event-title1">코코몽 마을 메타버스 이벤트 진행</div>
        <div class="event-sub1">코코몽 캐릭터가 플렉스한다! 빵빵!</div>
      </div>
      <div class="event-con">
        <img
          src="/static/images/Frame-5.png"
          loading="lazy"
          alt=""
          class="image-142"
        />
        <div class="event-box">
          <div class="event-box-con">
            <div class="open-noti none">마감</div>
            <div class="participate hide">112명 참여</div>
          </div>
        </div>
        <div class="event-title1">아바톡월드 시즌 2.5 이벤트 진행</div>
        <div class="event-sub1">당근밭에 당근캐고 선물 캐자!</div>
      </div>
      <div class="event-con">
        <img
          src="/static/images/Frame-4.png"
          loading="lazy"
          alt=""
          class="image-142"
        />
        <div class="event-box">
          <div class="event-box-con">
            <div class="open-noti none">마감</div>
            <div class="participate hide">112명 참여</div>
          </div>
        </div>
        <div class="event-title1">
          아바톡 공모전 Vol.1 내캐릭터 자기소개를 부탁해!
        </div>
        <div class="event-sub1">캐릭터를 보유한 작가 및 기업 참여 가능</div>
      </div>
    </div>
  {/if}
</div>

<style>
  .event-con-wrap {
    min-height: 670px;
    margin: auto;
    margin-top: 20px;
  }

  .event-con:hover {
    transform: scale(1.05);
  }

  .event-con {
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    margin: auto;
    min-height: -webkit-fill-available;
  }

  .ava-event {
    min-height: 1000px;
    margin-top: 110px;
    max-width: 1400px;
    padding: 0px 20px;
  }

  .image-142 {
    width: auto;
    margin-right: 0px;
  }

  .event-con {
    width: 90%;
  }

  .event-title {
    margin: auto;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 16px;
  }

  @media screen and (max-width: 1280px) {
    .ava-event {
      margin-top: 100px;
    }
  }

  @media screen and (max-width: 1024px) {
    .ava-event {
      margin-top: 93px;
    }
  }

  @media screen and (max-width: 1024px) {
    .ava-event {
      margin-top: 76px;
    }
  }

  @media screen and (max-width: 479px) {
    .ava-event {
      margin-top: 66px;
    }

    .e-title {
      margin-bottom: 0;
      line-height: 40px;
      font-size: 20px;
      padding-left: 0;
    }
    .event-sub1 {
      line-height: 26px;
    }
  }
</style>
